import React, { useEffect, useState } from "react";
import { changePasswordService } from "../../../services/apiService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { showSnackbar } from "../../../comopnents/snackbar";

const AdminProfile = () => {
  const [user, setUser] = useState(null);
  // install react-icons if not
  const [showConfirm, setShowConfirm] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [passwords, setPasswords] = useState({
    current: "",
    new: "",
    confirm: "",
  });

  useEffect(() => {
    const businessInfo = localStorage.getItem("businessInfo");

    const userData = {
      firstName: localStorage.getItem("firstName"),
      lastName: localStorage.getItem("lastName"),
      dob: localStorage.getItem("dob"),
      email: localStorage.getItem("email"),
      phone: localStorage.getItem("mobile"),
      role: localStorage.getItem("userType"),
      country: localStorage.getItem("country"),
      city: localStorage.getItem("city"),
      postalCode: localStorage.getItem("postalCode"),
      avatar: localStorage.getItem("avatar"),
      businessInfo: businessInfo ? JSON.parse(businessInfo) : null,
    };

    setUser(userData);
  }, []);

  const handleSavePassword = async () => {
    if (passwords.new !== passwords.confirm) {
      showSnackbar("error", "New password and confirm password do not match!");
      return;
    }

    try {
      const payload = {
        userid: localStorage.getItem("userId"),
        password: passwords.new,
        password2: passwords.confirm,
      };

      const res = await changePasswordService(payload);
      console.log(res);

      // Pass response directly — works for {msg} or {data}
      showSnackbar("success", res);

      setPasswords({ current: "", new: "", confirm: "" });
    } catch (error) {
      console.error(error);

      showSnackbar(
        "error",
        error?.response?.data || "Failed to change password. Please try again.",
      );
    }
  };
  const handleLogout = () => {
    localStorage.clear(); // or remove specific token
    window.location.href = "/"; // redirect
  };
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };
  if (!user) return <p style={{ padding: "20px" }}>Loading...</p>;

  return (
    <div className="profile-container">
      <div className="header-card">
        <div>
          <div className="header-container">
            <div className="header-left">
              <div className="avatar-placeholder">
                {user.firstName?.charAt(0)}
                {user.lastName?.charAt(0)}
              </div>

              <div className="header-info">
                <h2>
                  {user.firstName} {user.lastName}
                </h2>
                <p className="role">{user.role}</p>
              </div>
            </div>

            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>

          {/* Personal Info inside header */}
          <div className="personal-info-inline">
            <div className="field-row">
              <span className="field-label">First Name</span>
              <span className="field-value">{user.firstName}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Last Name</span>
              <span className="field-value">{user.lastName}</span>
            </div>
            <div className="field-row">
              <span className="field-label">GST</span>
              <span className="field-value">{user.GST || "-"}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Email Address</span>
              <span className="field-value">{user.email}</span>
            </div>
            <div className="field-row">
              <span className="field-label">Phone Number</span>
              <span className="field-value">{user.phone}</span>
            </div>
            <div className="field-row">
              <span className="field-label">User Role</span>
              <span className="field-value">{user.role}</span>
            </div>
          </div>
          <div className="info-card">
            <div className="card-header">
              <h3>Change Password</h3>
            </div>
            <div className="card-content">
              <div className="field-row">
                <span className="field-label">New Password</span>
                <div className="password-field">
                  <input
                    type={showNew ? "text" : "password"}
                    name="new"
                    value={passwords.new}
                    onChange={handlePasswordChange}
                    className="input-field"
                    placeholder="Enter new password"
                  />
                  <span
                    className="toggle-visibility"
                    onClick={() => setShowNew(!showNew)}
                  >
                    {showNew ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              <div className="field-row">
                <span className="field-label">Confirm Password</span>
                <div className="password-field">
                  <input
                    type={showConfirm ? "text" : "password"}
                    name="confirm"
                    value={passwords.confirm}
                    onChange={handlePasswordChange}
                    className="input-field"
                    placeholder="Confirm new password"
                  />
                  <span
                    className="toggle-visibility"
                    onClick={() => setShowConfirm(!showConfirm)}
                  >
                    {showConfirm ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              <div style={{ textAlign: "right", marginTop: "15px" }}>
                <button
                  className="save-btn"
                  onClick={handleSavePassword}
                  disabled={!passwords.new.trim() || !passwords.confirm.trim()}
                  style={{
                    opacity:
                      !passwords.new.trim() || !passwords.confirm.trim()
                        ? 0.5
                        : 1,
                    cursor:
                      !passwords.new.trim() || !passwords.confirm.trim()
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>{`
      .personal-info-inline {
  margin-top: 20px;
  background: #f8fafc;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0,0,0,0.05);
}

.personal-info-inline .field-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
}

.personal-info-inline .field-row:last-child {
  border-bottom: none;
}

.personal-info-inline .field-label {
  font-weight: 600;
  color: #4a5568;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar-placeholder {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #4caf50;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info h2 {
  margin: 0;
  font-size: 18px;
}

.role {
  margin: 0;
  font-size: 13px;
  color: gray;
}

.logout-btn {
  padding: 6px 14px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.personal-info-inline .field-value {
  color: #2d3748;
}
        .profile-container {
          max-width: 1200px;
          margin: 40px auto;
          padding: 0 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          color: #333;
          background: #f5f7fa;
          min-height: 100vh;
        }

        .header-card {
  display: flex;
  align-items: flex-start; /* align avatar to top of header info */
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
}
.avatar-placeholder {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    margin-right: 20px;

    margin-top: -20px; /* moves it up */
}

        .header-info h2 {
          margin: 0 0 8px 0;
          font-size: 24px;
          font-weight: 600;
          color: #2d3748;
        }

        .header-info .role {
          margin: 0 0 4px 0;
          font-size: 16px;
          color: #4a5568;
          font-weight: 500;
              width: 821px;
        }

        .header-info .location {
          margin: 0;
          font-size: 14px;
          color: #718096;
        }

.cards-grid {
  display: flex;
  flex-direction: column; /* ensures stacked cards */
  gap: 20px;
  width: 100%; /* full width below header */
}
        .info-card {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          overflow: hidden;
        }

        .card-header {
          padding: 20px 25px;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }

        .card-header h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
        }

        .card-content {
          padding: 25px;
        }

        .field-row {
          display: flex;
          padding: 14px 0;
          border-bottom: 1px solid #f1f5f9;
          align-items: flex-start;
        }

        .field-row:last-child {
          border-bottom: none;
        }

        .field-label {
          font-weight: 600;
          color: #4a5568;
          font-size: 14px;
          min-width: 140px;
          flex-shrink: 0;
        }

        .field-value {
          color: #2d3748;
          font-size: 15px;
          flex-grow: 1;
        }

        @media (max-width: 1024px) {
          .cards-grid {
            grid-template-columns: 1fr;
            gap: 20px;
          }
        }

        @media (max-width: 768px) {
          .profile-container {
            margin: 20px auto;
            padding: 0 15px;
          }

          .header-card {
            flex-direction: column;
            text-align: center;
            padding: 20px;
          }

          .avatar-placeholder {
            margin-right: 0;
            margin-bottom: 15px;
          }

          .field-row {
            flex-direction: column;
            padding: 12px 0;
          }

          .field-label {
            min-width: auto;
            margin-bottom: 4px;
            font-size: 13px;
            color: #718096;
          }

          .field-value {
            font-size: 16px;
          }

          .card-header {
            padding: 15px 20px;
          }

          .card-content {
            padding: 20px;
          }
        }
          /* Password field wrapper */
.password-field {
  position: relative;
  display: flex;
  align-items: center;
}

.password-field input {
  width: 100%;
  padding: 10px 40px 10px 12px; /* space for icon */
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border 0.2s;
}

.password-field input:focus {
  border-color: #667eea;
}

.password-field .toggle-visibility {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #718096;
  font-size: 16px;
  user-select: none;
}

.password-field .toggle-visibility:hover {
  color: #4a5568;
}

      `}</style>
    </div>
  );
};

export default AdminProfile;
